import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import MailTwoToneSvg from "@ant-design/icons-svg/es/asn/MailTwoTone";
import AntdIcon from "../components/AntdIcon";
var MailTwoTone = function MailTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MailTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  MailTwoTone.displayName = 'MailTwoTone';
}
export default /*#__PURE__*/React.forwardRef(MailTwoTone);